import { render, staticRenderFns } from "./BottomPane.vue?vue&type=template&id=09fc26f8&scoped=true&"
import script from "./BottomPane.vue?vue&type=script&lang=js&"
export * from "./BottomPane.vue?vue&type=script&lang=js&"
import style0 from "./BottomPane.vue?vue&type=style&index=0&id=09fc26f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc26f8",
  null
  
)

export default component.exports